import { allCountries } from 'country-telephone-data';

/**
 * Backing data for CountrySelect.vue (both the plain country picker and the
 * phone dial-code picker) — flag rendered via the flag-icons CSS package
 * (`fi fi-<iso2>` classes), not emoji, since regional-indicator flag emoji
 * render as bare two-letter codes on Windows browsers with no flag glyph
 * support.
 *
 * `country-telephone-data`'s `name` sometimes carries a native-script
 * suffix (e.g. "Afghanistan (افغانستان)") — stripped here so the plain
 * country field stores/displays a clean English name.
 */
export const countries = allCountries.map((c) => ({
  name: c.name.replace(/\s*\([^)]*\)\s*$/, '').trim(),
  iso2: c.iso2,
  dialCode: `+${c.dialCode}`,
}));

export function flagClass(iso2) {
  return iso2 ? `fi fi-${iso2}` : '';
}
